<form [formGroup]="form">
  <app-input-group>
    <label appLabel>{{ 'date.validFrom' | translate }}</label>
    <input type="date" appInputDate formControlName="decommissioningDate" placeholder="{{ 'date.enterDate' | translate }}"/>
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'meter.meterNumber' | translate }}</label>
    <input type="text" appInput formControlName="meterNumber" readonly
           placeholder="{{ 'meter.meterNumber' | translate }}"/>
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'meter.alternativeMeterNumber' | translate }}</label>
    <input type="text" appInput formControlName="alternateMeterNumber" readonly
           placeholder="{{ 'meter.alternativeMeterNumber' | translate }}"/>
  </app-input-group>

  <app-input-group>
    <label appLabel>{{ 'meter.serialNumber' | translate }}</label>
    <input type="text" appInput formControlName="serialNumber" readonly
           placeholder="{{ 'meter.serialNumber' | translate }}"/>
  </app-input-group>
</form>
